export default __webpack_public_path__ + "static/media/NOTO_SANS_600.99a8e0eb.ttf";